<template>
  <div class="list-carousel" v-if="data && data.length > 1">
    <VueSlickCarousel v-bind="settings">
      <div v-for="item in data" v-bind:key="item.contentId" class="carousel-item">
        <div class="item-wrap">
          <div class="item-thumb" @click="$router.push(`/ip-view/${item.contentId}`)">
            <img v-bind:src="getThumbnail(item)" class="img-fit" @error="replaceByDefault" />
          </div>
          <div class="item-body">
            <a
              :href="`#/ip-view/${item.contentId}`"
              class="item-title"
            >{{item.title}}</a>
            <div class="item-description">{{item.summary}}</div>
            <div class="item-top">
              <div>
                <img
                  src="@/assets/images/medal.svg"
                  width="14.3px"
                  height="16.6px;"
                  style="margin-top: -2px;"
                />
              </div>
              <div class="item-author">{{item.author}}</div>
              <span class="footer_dot">
                <i class="fa fa-circle"></i>
              </span>
              <div class="time">{{formatDateTime(item.publishedTime)}}</div>
            </div>
          </div>
          <div class="item-bottom">
            <div class="tags-list">
              <div class="tag-item level" v-if="item.level">Level {{item.level}}</div>
              <div
                class="tag-item confidential"
                v-if="item.confidentialLevel"
              >{{item.confidentialLevel}}</div>
              <div
                v-for="(tag,index) in item.tags"
                class="tag-item"
                :key="index"
                @click="setTechType(tag)"
              >{{tag.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import moment from "moment";
import * as CONFIG from "@/config/index.js";
import axios from "axios";
export default {
  name: "ListCarousel",
  components: { VueSlickCarousel },
  data() {
    return {
      screenWidth: 0,
      settings: {
        dotsClass: "slick-dots sku-dot-class",
        dots: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        autoplaySpeed: 2000
      }
    };
  },
  props: {
    data: {
      type: Array,
      required: false
    },
    slidesToShow:{
      type: Number,
      required: false
    },
    slidesToScroll:{
      type: Number,
      required: false
    }
  },
  mounted() {
    this.fixSlide();
    if(this.slidesToShow){
      this.settings.slidesToShow = this.slidesToShow;
    }
    if(this.slidesToScroll){
      this.settings.slidesToScroll = this.slidesToScroll;
    }
  },
  methods: {
    fixSlide() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.settings.slidesToShow = 1;
      }
      else if(this.screenWidth >= 768 && this.screenWidth < 1024){
        this.settings.slidesToShow = 2;
      }
      else {
        this.settings.slidesToShow = 3;
      }
    },
    setTechType(tech) {
      localStorage.setItem("tech", JSON.stringify(tech));
      window.location.href = `${CONFIG.CLIENT_URL}/#/advanced-search/`;
    },

    formatDateTime: function(time) {
      return moment(time).fromNow();
    },
    replaceByDefault(e) {
      e.target.style.opacity = "0";
    },
    getThumbnail(item) {
      let { thumb } = item;
      if (!thumb) {
        return "static/img/Login_computer.b246d6e.png";
      }
      return CONFIG.API_URL + "/image/" + thumb.split(",")[0];
    }
  }
};
</script>
<style scoped>
.carousel-item {
  padding: 10px;
}
.carousel-item .item-wrap {
  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.carousel-item .item-wrap .item-top {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.carousel-item .item-wrap .item-bottom {
  background-color: #f6fbfb;
  padding: 10px 30px 15px;
}

.carousel-item .item-wrap .item-bottom .tags-list {
  flex-wrap: wrap;
  display: flex;
  height: 50px;
  overflow: hidden;
}

.carousel-item .item-wrap .item-bottom .tag-item {
  padding-top: 1px !important;
  border: 1px solid #0855dc00;
  color: #3199bb !important;
  font-size: 10px !important;
  background: #e3e9f0;
  margin-top: 5px !important;
  margin-right: 5px !important;
  border-radius: 10px;
  height: 19px;
  padding: 2px 10px;
  cursor: pointer;
}

.carousel-item .item-wrap .item-bottom .tag-item.level {
  background: #3199bb !important;
  color: #fff !important;
  text-transform: uppercase;
}

.carousel-item .item-wrap .item-bottom .tag-item.confidential {
  background: #0855dc00;
  border: 1px solid #3199bb;
}

.carousel-item .item-wrap .item-top .item-author {
  font-weight: 700;
  font-size: 12px;
  margin-left: 4px;
}

.carousel-item .item-wrap .item-top .footer_dot {
  font-size: 6px;
  margin: 2px 6px 0 6px;
}

.carousel-item .item-wrap .item-top .time {
  font-size: 11px;
}

.carousel-item .item-wrap .item-body {
  padding: 20px 30px;
}

.carousel-item .item-wrap .item-body .item-title {
  font-size: 16px;
  text-align: left;
  color: #3299ba;
  line-height: 1.44;
  letter-spacing: 0.13px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-word;
}

.carousel-item .item-wrap .item-body .item-description {
  font-size: 13px;
  line-height: 1.33;
  letter-spacing: 0.06px;
  text-align: left;
  color: #1e242f;
  margin-top: 10px;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
  height: 35px;
  overflow: hidden;
}

.carousel-item .item-wrap .item-thumb {
  height: 200px;
  background-size: cover;
}

.slick-slider:hover .slick-prev {
  background-image: none;
  color: #ddd;
}

.slick-slider:hover .slick-next {
  background-image: none;
  color: #ddd;
}

.item-thumb:hover {
  opacity: 0.7;
  cursor: pointer;
}

.item-title:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/ListCarousel.vue